import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Form = () => {



    const notify = () => {
        toast.success('Data Added!', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }


    const [data, setData] = useState({
        FIELD: "",
        Name: "",
        Company: "",
        "Job Title": "",
        Address: "",
        "Phone Number": "",
        "Email 1": "",
        Websites: "",
    });

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();



        fetch("http://crm.arunexcello.com:3000/api/data", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })

            .catch((err) => {
                console.log(err);
            });

        notify();
    };





    return (
        <>

            <>

                <div className="registerform">
                    <h1>Add new contact</h1>
                    <br />
                    <form onSubmit={handleSubmit}>
                        <label>
                            FIELD:
                            <input type="text" name="FIELD" value={data.FIELD} onChange={handleChange} />
                        </label>

                        <label>
                            Name:
                            <input type="text" name="Name" value={data.Name} onChange={handleChange} />
                        </label>
                        <label>
                            Company:
                            <input type="text" name="Company" value={data.Company} onChange={handleChange} />
                        </label>
                        <label>
                            Job Title:
                            <input type="text" name="Job Title" value={data['Job Title']} onChange={handleChange} />
                        </label>
                        <label>
                            Address:
                            <input type="text" name="Address" value={data.Address} onChange={handleChange} />
                        </label>
                        <label>
                            Phone Number:
                            <input type="text" name="Phone Number" value={data['Phone Number']} onChange={handleChange} />
                        </label>
                        <label>
                            Email 1:
                            <input type="text" name="Email 1" value={data['Email 1']} onChange={handleChange} />
                        </label>
                        <label>
                            Websites:
                            <input type="text" name="Websites" value={data.Websites} onChange={handleChange} />
                        </label>
                        <button type="submit">Add Contact</button>

                    </form>

                    <ToastContainer
                        position="bottom-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                    />


                </div>
            </>



        </>);
};

export default Form;
